<template>
  <div @click="removeWidget"><v-icon color="white">mdi-close-box</v-icon> Remove {{ widgetName }}</div>
</template>

<script>
export default {
  name: 'RemoveButton',
  props: {
    widgetPosition: {
      type: String,
      required: true,
      default: ''
    },
    widgetName: {
      type: String,
      required: true,
      default: ''
    }
  },
  methods: {
    removeWidget() {
      this.$store.dispatch('dashboard/updateWidgetType', {
        [this.widgetPosition]: 'blank'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  
</style>
